export const EMPTY_FN = () => {};
export const EMPTY_OBJ = {};
export const EMPTY_ARRAY = [];

export const TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const UA = {
    HARMONY: 'harmony',
    IOS: 'ios',
    ANDROID: 'android'
};

export const UPLOAD_FILE_COUNT = {
    SINGLE: 1,
    MULTI: 10
};

// 允许进行图片预览的最大图片大小,超出限制显示图片icon不显示具体图片内容
export const MAX_IMAGE_VIEW_SIZE = 20 * 1024 * 1024;
// 允许office文件预览的大小限制，100M
export const MAX_OFFICE_VIEW_SIZE = 100 * 1024 * 1024;

// 分隔符
export const SEP = {
    COMMA: ', ' // 逗号分隔符，统一使用英文逗号 + 空格
};

// 多关键词搜索关键词个数限制
export const MAX_KEYWORDS_COUNT = 20;

// 键码
export const KEY_CODE = {
    ENTER: 13,
    DOWN: 40,
    UP: 38
};

export const FALLBACK_REGION = {
    use12Hour: false,
    dateTimeFormat: {
        ym: 'YYYY-MM',
        ymd: 'YYYY-MM-DD',
        hm: 'HH:mm',
        hms: 'HH:mm:ss',
        ymd_hm: 'YYYY-MM-DD HH:mm',
        ymd_hms: 'YYYY-MM-DD HH:mm:ss'
    },
    weekStart: 1,
    yearStart: 4,
    decimalSeparator: '.',
    thousandSeparator: ','
} as const;

// 部门路径最大显示层级
export const DEPT_LEVEL_MAX = 10;
